<template>
  <div>
    <a-card>
      <span slot="title" class="title">{{ `${titlepage.toUpperCase()} LIST` }}</span>
      <div slot="extra">
        <a-input-search
          placeholder="input search text"
          style="width: 300px"
          v-model="search"
        />
      </div>
      <a-tabs :activeKey="activetab" @change="handleTab">
        <a-tab-pane style="margin:auto" key="process">
          <template slot="tab">
            <span>Need Process</span>
            <a-badge
              key="badge"
              class="m-badge m-badge-small"
              :count="list_process.length"
              :numberStyle="{ backgroundColor: 'red' }"
              v-if="list_process.length > 0"
            >
            </a-badge>
          </template>
          <div class="loading" v-if="loading.process">
            <a-spin :spinning="loading.process" tip="Loading..."></a-spin>
          </div>
          <a-table
            v-else
            :columns="column_process"
            :dataSource="process_list"
            id="id_pfi"
            size="small"
            :pagination="pagination"
            bordered
            :scroll="{ x: 100 }"
          >
            <a
              slot="no"
              slot-scope="item"
              @click="handleLink(item.jns_transaksi, item.id_transaksi)"
              >{{ item.no_sppd }}</a
            >
             <span slot="date" slot-scope="item">
              {{ moment(item.create_dt).format('DD-MM-YYYY') }}
             </span>
            <span slot="value" slot-scope="amount">
              <CurrencyJustified
                v-if="amount.bailout_value"
                :currencyValue="'IDR'"
                :valueNumber="amount.bailout_value"
              />
              <div v-else style="text-align:center;width:100%">-</div>
            </span>
            <span slot="balance" slot-scope="amount">
              <CurrencyJustified
                v-if="amount.sisa"
                :key="amount.key"
                :currencyValue="amount.currency"
                :valueNumber="amount.sisa"
              />
              <div v-else style="text-align:center;width:100%">-</div>
            </span>
            <span slot="update_by" slot-scope="item">
              <span v-if="item.tlc_updated">
                {{ item.tlc_updated }} /
                {{
                  item.date_updated
                    ? moment(item.date_updated, getDateTimeStandartFormat).format(
                        getDefaultDateFormat
                      )
                    : "-"
                }}
              </span>
              <span v-else>
                -
              </span>
            </span>
            <span slot="centang" slot-scope="item">
              <!-- <a-popconfirm
                :key="item.key"
                title="Are you sure to change ?"
                @confirm="changeActionItem(item)"
                ok-text="Yes"
                cancel-text="No"
              > -->
                <a-button :key="item.key" type="primary" @click="handlemodal(item)"
                :disabled="item.proses=='disabled'"
                >
                  Process
                </a-button>
              <!-- </a-popconfirm> -->
            </span>
          </a-table>
        </a-tab-pane>
        <a-tab-pane tab="Bailout List" key="release">
          <div class="loading" v-if="loading.release">
            <a-spin :spinning="loading.release" tip="Loading..."></a-spin>
          </div>
          <a-table
            v-else
            :columns="column_release"
            :dataSource="release_list"
            id="id_ep1"
            size="small"
            :pagination="pagination"
            bordered
            :scroll="{ x: 100 }"
          >
            <span
              slot="no"
              slot-scope="item"
              >{{ item.no }}</span
            >
            <a
              slot="no_trans"
              slot-scope="item"
              @click="handleLink(item.jns_transaksi, item.id_transaksi)"
              >{{ item.no_sppd }}</a
            >
            <span slot="date" slot-scope="item">
              {{ moment(item.create_dt).format('DD-MM-YYYY') }}
             </span>
            <span slot="value" slot-scope="amount">
              <CurrencyJustified
                v-if="amount.bailout_value"
                :currencyValue="'IDR'"
                :valueNumber="amount.bailout_value"
              />
              <div v-else style="text-align:center;width:100%">-</div>
            </span>
            <span slot="pettycash" slot-scope="item">
              <a
                v-if="item.no_kas"
                @click="handleLink('pettycash', item.id_kas)"
                >{{ item.no_kas }}</a
              >
              <div v-else style="text-align:center;width:100%">-</div>
            </span>
            <span slot="nbr" slot-scope="item">
              <a v-if="item.no_bailout_report"
                @click="handleLink('bailout', item.id_bailout_report)"
                >{{ item.no_bailout_report }}</a
              >
              <div v-else style="text-align:center;width:100%">-</div>
            </span>
            <span slot="Document" slot-scope="item">
                <a-button type="default"
                icon="eye" @click="viewDoc(item.file_transfer)"
                :disabled="item.file_transfer==null"
                >
                  View
                </a-button>
            </span>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>
    <a-modal
      v-model="processModal"
      :maskClosable="false"
    >
      <span slot="title">
        Process Bailout Fund
      </span>
      <a-form-model ref="modalForm" :model="modalForm" :rules="rulesForm">
        <a-form-model-item label="No"
        :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
        prop="no" ref="no">
          <a-input
            disabled
            class="m-width-full"
            autocomplete="off"
            v-model="modalForm.no"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="Create Date"
          :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
          prop="create_dt" ref="create_dt">
          <a-input
            disabled
            class="m-width-full"
            autocomplete="off"
            v-model="modalForm.create_dt"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="TLC"
          :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
          prop="tlc_create" ref="tlc_create">
          <a-input
            disabled
            class="m-width-full"
            autocomplete="off"
            v-model="modalForm.tlc_create"
          ></a-input>
        </a-form-model-item>
        <a-form-model-item label="Description"
        :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
        prop="description" ref="description">
          <a-textarea
            disabled
            class="m-width-full"
            autocomplete="off"
            v-model="modalForm.description"
          ></a-textarea>
        </a-form-model-item>
        <a-form-model-item label="Value"
        :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
        prop="bailout_value" ref="bailout_value">
          <a-input-number
            :min="0"
            class="m-width-full m-text-align right"
            @keydown="onlyNumber"
            :formatter="
              (value) => `Rp ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
            "
            :parser="(value) => value.replace(/\\s?|(,*)/g, '')"
            disabled
            v-model="modalForm.bailout_value"
          ></a-input-number>
        </a-form-model-item>
        <a-form-model-item label="Note"
        :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
        prop="note" ref="note">
          <a-textarea
            class="m-width-full"
            autocomplete="off"
            v-model="modalForm.note"
          ></a-textarea>
        </a-form-model-item>
      
        <a-form-model-item label="Upload File" prop="upload" ref="upload"
        :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }"
        >
          <a-upload :showUploadList="true" :fileList="pushfile" :beforeUpload="beforeUploadFile"
            :remove="handleRemoveFile" v-model="modalForm.upload">
            <a-button> <a-icon type="upload" />&nbsp;Select File </a-button>
          </a-upload>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button key="back" @click="handleCloseModal"> Cancel </a-button>
        <a-button key="submit" type="primary" @click="handleOkModal" :loading="loadingmodalsave">
          Save
        </a-button>
      </template>
    </a-modal>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import axios from "axios";
import moment from "moment";
import _ from "lodash";
import GlobalMethod from "@/mixins/GlobalMethod.js";
export default {
  name: "Bailoutfund",
  mixins: [GlobalMethod],
  data() {
    let checkPending;
    let checkValue = (rule, value, callback) => {
      clearTimeout(checkPending);
      if (!value) {
        return callback(new Error("Please input the value"));
      }

      const limit = parseFloat(this.modalForm.maxval);
      if (value > limit) {
        callback(new Error(`Value must be less than ${this.modalForm.maxval}`));
      } else {
        callback();
      }
    };

    let doc_validation = (rule, value, callback) => {
      if (this.pushfile == null || this.pushfile.length==0) {
        callback(new Error("Upload File Cannot be Empty!"));
      } else {
        callback();
      }
    };
    return {
      doc_validation,
      activetab: "process",
      typepage: "",
      titlepage: "",
      list_release: [],
      list_process: [],
      loading: {
        release: false,
        process: false,
      },
      pagination: {
        onChange: (page) => {
          console.log(page);
        },
        pageSize: 20,
        size: "small",
      },
      search: "",
      processModal: false,
      loadingmodalsave: false,
      modalForm : {
        no : null,
        description : null,
        val : null,
        note: null,
        bailout_value: null,
        upload: null,
      },
      rulesForm :{
        no: [
          {
            required: false,
          },
        ],
        description: [
          {
            required: false,
          },
        ],
        bailout_value: [
          {
            required: true,
            trigger: "blur",
            validator: checkValue,
          },
        ],
        note:[
          {
            required: true,
          },
        ],
        upload: [
          {
            required: true,
            trigger: "change",
            validator: doc_validation
          },
        ],
      },
      pushfile: [],
    };
  },
  computed: {
    ...mapGetters([
      "getScreen",
      "getAuth",
      "getDefaultDateFormat",
      "getDateTimeStandartFormat",
      "getTypePage",
    ]),
    column_process() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      let kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: this.getscreen ? 20 : 50,
          align: "center",
        },
        {
          title: "No",
          width: this.getscreen ? 100 : 250,
          key: "no",
          scopedSlots: { customRender: "no" },
        },
        {
          title: "Date",
          width: 100,
          key: "date",
          align: "center",
          scopedSlots: { customRender: "date" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: this.getscreen ? 180 : 250,
        },
        {
          title: "Type",
          key: "jns_transaksi",
          dataIndex: "jns_transaksi",
          width: 70,
          align: "center",
        },
        {
          title: "TLC",
          key: "tlc",
          dataIndex: "tlc_create",
          width: 70,
          align: "center",
        },
        {
          title: "Value",
          key: "value",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "value" },
        },
        {
            title: "Action",
            key: "centang",
            fixed: "right",
            width: this.getscreen ? 50 : 100,
            align: "center",
            scopedSlots: { customRender: "centang" },
          },
      ];

      if(this.isSpecialMenuMon && !this.isKasKecil){
        kolom.splice(7, 1);
      }
      return kolom;
    },
    column_release() {
      let { sortedInfo, filteredInfo } = this;
      sortedInfo = sortedInfo || {};
      filteredInfo = filteredInfo || {};

      const kolom = [
        {
          title: "#",
          key: "number",
          dataIndex: "number",
          width: this.getscreen ? 20 : 50,
          align: "center",
        },
        {
          title: "No",
          width: this.getscreen ? 100 : 250,
          key: "no_trans",
          scopedSlots: { customRender: "no_trans" },
        },
        {
          title: "Date",
          width: 100,
          key: "date",
          align: "center",
          scopedSlots: { customRender: "date" },
        },
        {
          title: "Description",
          key: "deskripsi",
          dataIndex: "deskripsi",
          width: this.getscreen ? 180 : 250,
        },
        {
          title: "Type",
          key: "jns_transaksi",
          dataIndex: "jns_transaksi",
          width: 70,
          align: "center",
        },
        {
          title: "TLC",
          key: "tlc",
          dataIndex: "tlc_create",
          width: 70,
          align: "center",
        },
        {
          title: "Value",
          key: "value",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "value" },
        },
        {
          title: "No Petty Cash",
          key: "pettycash",
          width: this.getscreen ? 100 : 200,
          scopedSlots: { customRender: "pettycash" },
        },
        {
          title: "No Bailout Report",
          key: "nbr",
          width: this.getscreen ? 100 : 220,
          align: "center",
          fixed: "right",
          scopedSlots: { customRender: "nbr" },
        },
        {
          title: "Document",
          key: "Document",
          width: 100,
          fixed: "right",
          scopedSlots: { customRender: "Document" },
        },
      ];
      return kolom;
    },
    release_list() {
      let output = this.list_release;

      if (this.search && this.activetab == "release") {
        output = output.filter(
          (obj) =>
            obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            moment(obj.date_updated)
              .format(this.getDefaultDateFormat)
              .toLowerCase()
              .indexOf(this.search.toLowerCase()) >= 0 ||
            obj.tlc_updated.toLowerCase().indexOf(this.search.toLowerCase()) >=
              0 ||obj.no_trans.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.value.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
      return output;
    },
    process_list() {
      let output = this.list_process;

      if (this.search && this.activetab == "process") {
        output = output.filter(
          (obj) =>
            obj.no.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.value.toLowerCase().indexOf(this.search.toLowerCase()) >= 0 ||
            obj.deskripsi.toLowerCase().indexOf(this.search.toLowerCase()) >= 0
        );
      }
      return output;
    },
    isSpecialMenuMon(){
      return this.$route.meta.spcl_menu_monitoring ? true : false
    },
    isKasKecil(){
      return _.filter(this.getAuth.job_desc,(obj) => obj=="Kas Kecil").length>0 ? true : false
    }
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    moment,
    async fetchData() {
      if (this.activetab == "release") {
        this.loading.release = true;
      } else {
        this.loading.process = true;
      }
      this.typepage = this.$route.meta.page_type;
      this.titlepage = this.$route.meta.page_title ? this.$route.meta.page_title : this.$route.meta.page_type;
      const release = axios({
        method: "get",
        url: this.$serviceUrl + "bailout_fund",
        params: {
          tab: "bailout list",
          jenis: this.typepage,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
      });

      const proses = axios({
        method: "get",
        url: this.$serviceUrl + "bailout_fund",
        params: {
          tab: "need process",
          jenis: this.typepage,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      }).catch((err) => {
        console.log(err);
        this.loading.release = false;
        this.loading.process = false;
      });

      return await new Promise((resolve, reject) => {
        axios
          .all([
            release.catch((err) => {
              console.log(err);
              return null;
            }),
            proses.catch((err) => {
              console.log(err);
              return null;
            }),
          ])
          .then((response) => {
            this.list_release = response[0] ? response[0].data.data : [];
            this.list_process = response[1] ? response[1].data.data : [];
            if (this.list_process.length > 0) {
              for (let index = 0; index < this.list_process.length; index++) {
                let col = [
                  {
                    ...this.list_process[index],
                    key: "a" + (index + 1),
                    number: index + 1,
                    dana_sts: false,
                  },
                ];
                this.list_process[index] = col[0];
              }
            }
            if (this.list_release.length > 0) {
              for (let index = 0; index < this.list_release.length; index++) {
                let col = [
                  {
                    ...this.list_release[index],
                    key: "b" + (index + 1),
                    number: index + 1,
                  },
                ];
                this.list_release[index] = col[0];
              }
            }
            this.loading.release = false;
            this.loading.process = false;
            resolve(response);
          })
          .catch((err) => {
            reject(err);
          });
      });
    },
    handleTab(val) {
      this.activetab = val;
      this.search = "";
      if (this.activetab == "release") {
        this.loading.release = true;
      } else {
        this.loading.process = true;
      }
      this.fetchData();
    },
    handleLink(jenis, id_) {
      let manifest = "";
      if (jenis == "PD") {
        manifest = "manifest";
      } else if (jenis == "PP") {
        manifest = "manifestPp";
      } else if (jenis == "pettycash") {
        manifest = "kaskecilmanifest";
      } else if (jenis == "klaimpd") {
        manifest = "manifestKlaimPd";
      } else if (jenis == "klaimpp") {
        manifest = "manifestKlaimPp";
      }else if (jenis == "klaimdirektur") {
        manifest = "manifestDirectur";
      }else if (jenis == "bkk") {
        manifest = "bkkManifestKeu";
      } else if (jenis == "klaim_cc") {
        manifest = "manifestKlaimCC";
      } else if (jenis == "klaim_cc_pd") {
        manifest = "manifestCCKlaimPd";
      } else if (jenis == "klaim_cc_pp") {
        manifest = "manifestKlaimCCPp";
      } else if (jenis == "bailout") {
        if(localStorage.getItem("nvpn") === "/verifikatorPelaporan"){
          manifest = "SpecialManifestBailoutReportVer"
        }else if(localStorage.getItem("nvpn") === "/FinancialControl"){
          manifest = "SpecialManifestBailoutReportFC";
        }else if(localStorage.getItem("nvpn") === "/akuntansiKeuangan"){
          manifest = "SpecialManifestBailoutReportACC";
        }else{
          manifest = "SpecialManifestBailoutReport";
        }
      }
       else {
        manifest = "lapUmppManifest";
      }
      const route = this.$router.resolve({
        name: manifest,
        params: { id: id_ },
      });
      window.open(route.href, "_blank");
    },
    changeActionItem() {
      this.$refs.modalForm.validate((valid) => {
        if (!valid) {
          this.displayMessage("form-warning");
          return;
        }
          
        if (this.modalForm.val > this.modalForm.maxval) {
          this.displayMessageValue("error-basic", "Value is grather than remaining balance!");
        }else{
        this.loadingmodalsave = true;

        let formData = new FormData();
        formData.append("file_transfer", this.modalForm.upload);
        formData.append("id_bailout", this.modalForm.id_bailout);
        formData.append("note", this.modalForm.note);

          axios({
            method: "post",
            url: this.$serviceUrl + "bailout_fund",
            processData: false,
            data: formData,
            auth: {
              username: this.getAuth.username,
              password: this.getAuth.password,
            },
            headers: {
              "Content-Type": "multipart/form-data",
              "X-API-KEY": this.getAuth.apikey,
            },
          })
          .then((response) => {
            this.handleCloseModal();
            this.displayMessage("success-save");
            Event.$emit("trigfetchnotif", true);
            this.fetchData();
            this.activetab = "release";
            this.loadingmodalsave = false;
          })
          .catch((err) => {
            let responses = Object.assign({}, err.response.data);
            this.displayMessageValue("error", responses);
            this.loadingmodalsave = false;
          });
        }
      });
    },
    handlemodal(item){
      this.processModal = true;
      this.modalForm = {
        id_bailout: item.id_bailout,
        no: item.no_sppd,
        create_dt: moment(item.create_dt).format("DD-MM-YYYY HH:mm:ss"),
        tlc_create: item.tlc_create,
        description: item.deskripsi,
        bailout_value: item.bailout_value,
        maxval: Number(item.value),
        note: null,
      };
    },
    resetfieldModal(){
      this.pushfile = [],
      this.modalForm = {
        id_bailout: null,
        no: null,
        create_dt: null,
        tlc_create: null,
        description: null,
        bailout_value: null,
        maxval: 0,
        note: null,
      };
    },
    handleCloseModal(){
      this.resetfieldModal();
      this.processModal = false;
    },
    handleOkModal(){
      this.changeActionItem();
    },
    viewDoc(path){
      window.open(this.$serviceUrl + path);
    },
    beforeUploadFile(file) {
      const FileSize = file.size / 1024 / 1024;
      if (FileSize > 10) {
        this.displayMessage("large-file-10mb");
      } else {
        this.pushfile = [file];
        this.modalForm.upload = file;
        return false;
      }
    },
    handleRemoveFile() {
      this.pushfile = [];
      this.modalForm.upload = null;
    },
    validatorFile(val){
      console.log('checkFileValue', val)
      // if (value !=null ) {
      //   callback(new Error(`Value must be less than ${this.modalForm.maxval}`));
      // } else {
      //   callback();
      // }
    }
  },
};
</script>

<style lang="less" scoped>
.title {
  text-transform: capitalize;
}
</style>
